import { location } from '@/services'
import { useQuery } from '@tanstack/react-query'

// ----------------------------------------------------------------------

type ReturnType = {
  dataWards: Ward[] | undefined
  isLoadingDataWards: boolean
  isPendingDataWards: boolean
}

export function useWards(addressType: string, districtId: string | number): ReturnType {
  const {
    data: dataWards,
    isLoading: isLoadingDataWards,
    isPending: isPendingDataWards,
  } = useQuery({
    queryKey: ['GET_DATA_WARDS', districtId?.toString(), addressType],
    queryFn: async () => location.getWards(districtId as number, addressType),
    enabled: !!districtId && !!addressType,
    retry: 0,
    staleTime: Infinity,
  })

  return {
    dataWards,
    isLoadingDataWards,
    isPendingDataWards,
  }
}

export function useOldWards(districtId: string | number) {
  const {
    data: dataWards,
    isLoading: isLoadingDataWards,
    isPending: isPendingDataWards,
  } = useQuery({
    queryKey: ['GET_DATA_OLD_WARDS', districtId?.toString()],
    queryFn: async () => location.getOldWards(districtId as number),
    enabled: !!districtId,
    retry: 0,
    staleTime: Infinity,
  })

  return {
    dataWards,
    isLoadingDataWards,
    isPendingDataWards,
  }
}
